import { ActivatedRoute } from '@angular/router';
import { BaseDataService, QueryParameter, ModalService, BaseCommonComponent, UserService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'yt-izvestaj-o-nenaplacenim-racunima',
    templateUrl: './izvestaj-o-nenaplacenim-racunima.component.html'
})

export class IzvestajONenaplacenimRacunimaComponent
extends BaseCommonComponent
implements OnInit {
    
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected userService: UserService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

    rbItems=[
        {
            Name:this.translateService.instant('IZVESTAJONENAPLACENIMRACUNIMA.POROKUPLACANJA.SINGULAR'),
            Value: 'R'
        },
        {
            Name:this.translateService.instant('IZVESTAJONENAPLACENIMRACUNIMA.POIZNOSU.SINGULAR'),
            Value: 'I'
        }
    ];

    parameterList: List<QueryParameter> = List([]);
    Url: QueryParameter = new QueryParameter();

    // Proveriti samo šta ovde treba da stoji za ID, zavisi od SP koja se poziva za izvšetaj...
    source = [
        { ID: 'komitent_id', Name: 'Komitent' },
        { ID: 'org_jed_id', Name: 'Organizaciona jedinica' }      
      ]

     //ako postoji samo jedna organizaciona jedinica onda da na MultiSelectu bute čekirana ta jedna org.jed.
     SkupiOrgJed(items)
     {
          if (items && items.length == 1)
       {
            this.baseFormGroup.patchValue({OrgJedIDS : items[0].ID});
            this.baseFormGroup.get('OrgJedIDS').updateValueAndValidity();
          }
    };
    
     ngOnInit() {
        super.ngOnInit();

        this.SkupiOrgJed(this.items); 
            let dateNow = new Date();
            this.baseFormGroup = new FormGroup({
              OdDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [Validators.required]),
              DoDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
              OrgJedIDS: new FormControl(null,[Validators.required]),
              KomitentID: new FormControl(null,[Validators.required]),
              PragTolerancije: new FormControl(0),
              RokIznos: new FormControl("R")
            })    
            
            this.addValidatorToFc("OdDatuma",Validators.required, 'required','IZVESTAJONENAPLACENIMRACUNIMA.ODDATUMA.VALIDATION.REQUIRED');
            this.addValidatorToFc("DoDatuma",Validators.required, 'required','IZVESTAJONENAPLACENIMRACUNIMA.DODATUMA.VALIDATION.REQUIRED'); 
            this.addValidatorToFc("OrgJedIDS",Validators.required, 'required','IZVESTAJONENAPLACENIMRACUNIMA.ORGJED.VALIDATION.REQUIRED'); 
            this.addValidatorToFc("KomitentID",Validators.required, 'required','IZVESTAJONENAPLACENIMRACUNIMA.KOMITENTNAZIV.VALIDATION.REQUIRED');
            
            this.Url.Name = 'url';
            this.Url.Value = '/fak/izvestajonenaplacenimracunima'
            this.parameterList = this.parameterList.push(this.Url);
      
    }  
   
}

